<template>
  <div :class="!isFirstLogin ? 'modal-template' : ''">
    <div id="edit-form">
      <div v-if="!isFirstLogin" class="pagination mx-auto">
        <span :class="enabledPage[1] ? 'enable' : 'disable'"></span>
        <span :class="enabledPage[2] ? 'enable' : 'disable'"></span>
      </div>
      <div v-if="!isFirstLogin" class="text-right">
        <button
          v-if="!isFirstLogin && !isNotAddWebsite"
          @click="doLaterDescription"
          class="later-btn"
        >
          Do it later
        </button>
      </div>
      <!--First Page-->
      <div v-if="!isOtherPlatform && enabledPage[1]" class="col-md-12 px-4 mx-auto">
        <div class="row">
          <div class="mx-auto mt-3">
            <h4 style="padding-bottom: 15px !important;" class="text-center font-weight-bold">Choose an installation method</h4>
          </div>
          <div style="padding-top: 17px;" class="option-border row mx-auto min-width-100">
            <img :src="require(`../assets/img/integrations/${selectedPlugin.logo}`)" height="50px" class="mt-1" alt="Plugin" />
            <div class="ml-3">
              <p class="text-first">Recommended</p>
              <h5 class="font-weight-bold">Install {{$isMida ? 'Mida' : 'Howuku'}} with {{ selectedPlugin.text }}</h5>
              <span>Get {{$isMida ? 'Mida' : 'Howuku'}} running on your site in just a few clicks.</span> <br/>
              <!-- <span>You can set up Howuku with {{ selectedPlugin.text }} plugin.</span> <br/> -->
              <div class="mt-2">
                <button @click="recommendPlugin === 'shopify' ? showGuide(3, selectedPlugin) : recommendPlugin === 'google-tag-manager' ?
                showGuide(3, selectedPlugin) : recommendPlugin === 'wordpress' ? showGuide($isMida ? 5 : 1, selectedPlugin) : recommendPlugin === 'opencart' ? showGuide(3, selectedPlugin) : showGuide(3, selectedPlugin)" class="btn btn-first mr-2">Connect</button>
                <button @click="otherPlatform(true)" class="btn btn-third">Other Platform</button>
              </div>
            </div>
          </div>
          <div id="manual-install" style="display: block; padding-top: 0; padding-bottom: 0;" class="split mx-auto mt-3 option-border row min-width-100">
            <img src="../assets/img/html2.png" height="55px" alt="Plugin" />
            <div style="display: inline-block !important; margin-left: 0.4rem !important;" class="ml-3">
              <h5 class="font-weight-bold">Install {{$isMida ? 'Mida' : 'Howuku'}} Manually</h5>
            </div>

            <div style="display: flex;" class="ml-3">
              <p class="overview-manual-1">1</p>
              <div class="margin-align">
                Paste the code into the <span class="font-weight-bold text-primary">&lt;HEAD&gt;</span>
                tag on every page where you want to optimize.
                <div style="margin-top: 0.5rem;">
                  <div class="clipboard mx-auto text-right">
                    <span
                      class="cursor-pointer btn mt-1 p-0"
                      id="btn-copy"
                      style="position: absolute; padding: 8px; font-size: 0.8rem; border-radius: 3px !important; padding-left: 4px !important; padding-right: 4px !important; background-color: #ffffff; right: 3.5rem;"
                      @click="copyToClipboard"
                    >
                      <font-awesome-icon icon="paste" class="fa-sm" style="font-size: 0.8rem;" />
                      Copy
                    </span>
                  </div>
                  <pre
                    style="margin-bottom: 8px;"
                    id="code-snippet"
                    class="font-weight-bold codeBlock2"
                    v-if="$isHowuku && 1 === 2"
                  >
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(h,o,w,u,k,u){
  u=['track','identify','converted'],h.o=h.howuku||{},
  u.map(function(n){return h.o[n]=h.o[n]||function(){(h.o[n].q=h.o[n].q||[]).push(arguments);};}),h.howuku=h.o,
  k=o.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{
                $session.get('company_id') === 1334 ? 'script.6ix.com'
                  : $isMida ? 'cdn.mida.so' : 'cdn.howuku.com'}}/js/{{
                $session.get('company_id') === 1334 ? 'track' : 'howu'
              }}.js",k.setAttribute("key",w),
  o.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ this.secretCode }}");
&lt;/script></pre
            >
                  <pre style="margin-bottom: 8px;" id="code-snippet" class="codeBlock2" v-else>
{{ fullCode }}
</pre>
                </div>
              </div>
            </div>
            <div v-if="$isMida" style="display: flex;" class="ml-3 mb-3">
              <div class="overview-manual-1"></div>
              <div>
                <toggle-button @change="triggerAntiflicker" v-model="antiflicker" class="my-auto" color="#2eb15a" :labels="true" /> <span class="tooltip-pop ml-2" rel="Anti-flickering refers to the prevention of sudden visual changes on a webpage or app which might occur during testing.">Include <b>anti-flickering</b> script</span><br><br>
                <toggle-button @change="triggerConsentCode" v-model="consentcode" class="my-auto" color="#2eb15a" :labels="true" /> <span class="tooltip-pop ml-2" rel="Show A/B test to visitors but only track consented users, this will require some coding efforts.">Use strict consent mode</span>

                <div v-if="consentcode" class="mt-3 pl-3 ml-3" style="border-left: 1px dashed #ccc!important">
                  <p class="small text-muted"><span class="badge badge-info">IMPORTANT</span> Execute the following code when cookie consent is accepted or declined through GTM or your Consent Management Tools:</p>
                  <pre id="code-snippet" class="codeBlock2">// to accept consent
mida.grantConsent(true)

// to decline consent
mida.grantConsent(false)</pre>       
<a href="https://mida.freshdesk.com/support/solutions/articles/154000146683-cookies-consent-and-mida-s-adherence" target="_blank" class="a-link text-muted">Learn how it works before implementation</a>     
                </div>                   
              </div>
              
            </div>            
            <!-- <div class="option-border">
              <span class="font-weight-bold">Share code to your team</span> <br/>
              <span>Need developer help?</span><br/>
              <a
                class="btn btn-third btn-md mt-4"
                :href="
                'mailto:?subject=' + this.userName + '%20has%20invited%20you%20to%20install%20' +
                this.$customdomain().name +
                '%20Tracking%20Code&amp;body='+ this.userName +'%20has%20shared%20the%20'+ this.$customdomain().name +
                '%20tracking%20code%20with%20you.%20It%27s%20a%20JavaScript%20snippet%20which%20has%20to%20be%20added%20' +
                'to%20the%20%3Chead%3E%20tag%20of%20'+this.websiteURL+'.%20This%20enables%20us%20to%20analyse%20' +
                'visitor%20engagement%20data%20and%20run%20some%20engagement%20campaigns.%20%0A%0AJust%20copy%20and%20paste' +
                '%20the%20code%20below.%0A%0A' + fullCode +
                '%0A%0ALet%20me%20know%20if%20there%20is%20anything%20you%20wish%20to%20know.%20We%20can%20reach%20out%20to%20'+
                this.$customdomain().name+'%20team.%20'
              "
                target="_blank"
              >Share Code</a
              >
            </div> -->
            <div style="display: flex;" class="ml-3">
              <p class="overview-manual-1">2</p>
              <div style="flex-grow: 1;" class="margin-align">
                <p class="pb-0 mb-0">Verify if {{ $isMida ? 'Mida' : 'Howuku' }} is receiving data from your site.</p>
                <div>
                  <input
                    style="display: inline-block;"
                    type="text"
                    v-model="websiteURL"
                    class="web-icon form-control verify-input"
                  />
                  <button @click="verifyWebsite()" class="btn btn-third my-3 verify-button">Verify Installation</button>
                  <span style="display: block;" v-if="!isValidURL" class="warning">Invalid website URL</span>
                </div>
              </div>
            </div>
          </div>
          <div class="py-4 mx-auto">
            <p class="d-inline"><b>Your Project Key:</b> <code class="ml-2">{{ secretCode }}</code></p>
            <div class="share-code ml-auto">
              <a
                class="mt-4"
                style="color: var(--color)"
                :href="
                'mailto:?subject=' + this.userName + '%20has%20invited%20you%20to%20install%20' +
                this.$customdomain().name +
                '%20Tracking%20Code&amp;body='+ this.userName +'%20has%20shared%20the%20'+ this.$customdomain().name +
                '%20tracking%20code%20with%20you.%20It%27s%20a%20JavaScript%20snippet%20which%20has%20to%20be%20added%20' +
                'to%20the%20%3Chead%3E%20tag%20of%20'+this.websiteURL+'.%20This%20enables%20us%20to%20analyse%20' +
                'visitor%20engagement%20data%20and%20run%20some%20engagement%20campaigns.%20%0A%0AJust%20copy%20and%20paste' +
                '%20the%20code%20below.%0A%0A' + fullCode +
                '%0A%0ALet%20me%20know%20if%20there%20is%20anything%20you%20wish%20to%20know.%20We%20can%20reach%20out%20to%20'+
                this.$customdomain().name+'%20team.%20'
              "
                target="_blank"
              >Need developer help? Share code to them!</a
              >
            </div>          
          </div>
        </div>
      </div>
      <!--First Page - Other Platform-->
      <div class="px-2 mb-2" v-if="(isOtherPlatform) && enabledPage[1]">
        <h4 class="font-weight-bold mb-4">Installation Guide</h4>
        <p>Connect with our ready plugin and start using {{$isMida ? 'Mida' : 'Howuku'}}!</p>
      </div>
      <div class="px-2" v-if="(isOtherPlatform) && enabledPage[1]">
        <div class="plugin-row">
          <template v-if="$isOptimize">
            <div v-for="(item, index) in optimizePluginList" :key="index" v-if="item.type == 'main' && item.plugin !== recommendPlugin">
              <div class="plugin-box" @click="item.plugin === 'shopify' ? showGuide(2, item) : item.plugin === 'wordpress' && $isMida ? showGuide(5, item) : showGuide(3, item)">
                <img :src="require(`../assets/img/integrations/${item.logo}`)" alt="" height="50px" style="object-fit: contain">
                <p class="mt-3 mb-0">{{item.text}}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div v-for="(item, index) in pluginList" :key="index" v-if="item.type == 'main' && item.plugin !== recommendPlugin">
              <div class="plugin-box" @click="item.plugin === 'shopify' ? showGuide(2, item) : item.plugin === 'wordpress' && $isMida ? showGuide(5, item) : showGuide(3, item)">
                <img :src="require(`../assets/img/integrations/${item.logo}`)" alt="" height="50px" style="object-fit: contain">
                <p class="mt-3 mb-0">{{item.text}}</p>
              </div>
            </div>
          </template>
        </div>
        <div class="row mt-4 mb-2 mx-auto">
          Other platforms that we are supported:
        </div>
        <div class="plugin-row">
          <template v-if="$isOptimize">
            <div v-for="(item, index) in optimizePluginList" :key="index" v-if=" item.type == 'other' && item.plugin !== selectedPlugin.plugin" >
              <div class="plugin-box" @click="showGuide(3, item)">
                <img :src="require(`../assets/img/integrations/${item.logo}`)" alt="" height="50px" style="object-fit: contain">
                <p class="mt-3 mb-0">{{item.text}}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div v-for="(item, index) in pluginList" :key="index" v-if=" item.type == 'other' && item.plugin !== selectedPlugin.plugin" >
              <div class="plugin-box" @click="showGuide(3, item)">
                <img :src="require(`../assets/img/integrations/${item.logo}`)" alt="" height="50px" style="object-fit: contain">
                <p class="mt-3 mb-0">{{item.text}}</p>
              </div>
            </div>
          </template>
          <template v-if="$isOptimize">
            <div class="plugin-box" @click="openLink('https://mida.freshdesk.com/support/solutions/folders/154000138048')">
              <p class="my-4 mx-auto">See more platforms</p>
            </div>
          </template>
          <template v-else>
            <div class="plugin-box" @click="openLink('https://howuku.freshdesk.com/support/solutions/folders/150000376970')">
              <p class="my-4 mx-auto">See more platforms</p>
            </div>
          </template>
        </div>
        <div class="paging-btn">
          <button @click="otherPlatform(false)" class="btn btn-muted">Back</button>
        </div>
      </div>
      <!--Second Page-->
      <div v-if="enabledPage[2]" class="col-md-12 px-4 mx-auto">
        <InstallGuide :selectedWidgetId="this.selectedWidgetId" :websiteURL="this.websiteURL" :secretCode="this.secretCode" :plugin="this.guidePlugin" :layout="this.toLayout" />
      </div>
      <!--Paging Button-->
      <div style="margin-top: 0;" class="paging-btn px-2">
        <button v-if="!enabledPage[1]" @click="backPage" class="btn btn-muted">
          Back
        </button>
        <button v-if="!enabledPage[1] && !isNotAddWebsite" @click="installComplete" class="btn btn-first">
          Complete
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import JSConfetti from 'js-confetti'
import InstallGuide from '@/components/InstallGuide.vue'
export default {
  name: 'InstallRecommendatation',
  components: {
    InstallGuide
  },
  props: {
    recommendPlugin: String,
    selectedWidgetId: String,
    isNotAddWebsite: Boolean,
    isFirstLogin: Boolean
  },
  data: () => ({
    antiflicker: false,
    secretCode: '',
    websiteURL: '',
    guidePlugin: '',
    toLayout: 1,
    userName: '',
    encodedURL: '',
    isOtherPlatform: false,
    isInstallManual: false,
    currentPage: 1,
    selectedPlugin: {},
    pluginList: [
      { plugin: 'wordpress', text: 'WordPress', logo: 'wordpress.png', type: 'main', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000072464-how-to-install-in-wordpress' },
      { plugin: 'shopify', text: 'Shopify', logo: 'shopify.png', type: 'other', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000072481-how-to-install-in-shopify' },
      { plugin: 'wix', text: 'Wix', logo: 'wix.png', type: 'other', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000072485-how-to-install-wix' },
      { plugin: 'webflow', text: 'Webflow', logo: 'webflow.png', type: 'main', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000077444-how-to-install-howuku-in-webflow' },
      { plugin: 'google-tag-manager', text: 'Google Tag Manager', logo: 'gtm.png', type: 'main', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000072462-how-to-install-in-google-tag-manager-gtm-' },
      { plugin: 'opencart', text: 'OpenCart', logo: 'open-cart.png', type: 'other', toURL: 'https://www.opencart.com/index.php?route=marketplace/extension/info&extension_id=39328&filter_category_id=8&filter_license=0&filter_download_id=59&sort=date_added' },
      { plugin: 'big-commerce', text: 'BigCommerce', logo: 'big-commerce.png', type: 'other', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000072482-how-to-install-in-bigcommerce' },
      { plugin: 'joomla', text: 'Joomla', logo: 'joomla.png', type: 'other', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000072483-how-to-install-joomla' },
      { plugin: 'magento', text: 'Magento', logo: 'magento.png', type: 'other', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000072463-how-to-install-in-magento' },
      // { plugin: 'presta-shop', text: 'PrestaShop', logo: 'presta-shop.png', type: 'other', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000072484-how-to-install-prestashop' },
      // { plugin: 'squarespace', text: 'SquareSpace', logo: 'square-space.png', type: 'other', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000072466-how-to-install-in-squarespace' },
      { plugin: 'hubspot', text: 'Hubspot', logo: 'hubspot.png', type: 'other', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000072465-how-to-install-in-hubspot' },
    ],
    optimizePluginList: [
      { plugin: 'wordpress', text: 'WordPress', logo: 'wordpress.png', type: 'main', toURL: 'https://howuku.freshdesk.com/support/solutions/articles/150000131012-wordpress' },
      { plugin: 'shopify', text: 'Shopify', logo: 'shopify.png', type: 'other', toURL: 'https://mida.freshdesk.com/support/solutions/articles/154000062522-how-to-install-mida-on-shopify' },
      { plugin: 'framer', text: 'Framer', logo: 'framer.png', type: 'other', toURL: 'https://mida.freshdesk.com/support/solutions/articles/154000191756-how-to-install-mida-on-framer' },
      { plugin: 'webflow', text: 'Webflow', logo: 'webflow.png', type: 'main', toURL: 'https://mida.freshdesk.com/support/solutions/articles/154000062439-how-to-install-mida-on-webflow' },
      { plugin: 'google-tag-manager', text: 'Google Tag Manager', logo: 'gtm.png', type: 'main', toURL: 'https://mida.freshdesk.com/support/solutions/articles/154000062408-how-to-install-mida-using-google-tag-manager-gtm-' },
      { plugin: 'big-commerce', text: 'BigCommerce', logo: 'big-commerce.png', type: 'other', toURL: 'https://mida.freshdesk.com/support/solutions/articles/154000062538-how-to-install-mida-on-bigcommerce' },
      { plugin: 'hubspot', text: 'Hubspot', logo: 'hubspot.png', type: 'other', toURL: 'https://mida.freshdesk.com/support/solutions/articles/154000062541-how-to-install-mida-on-hubspot' },
      { plugin: 'wix', text: 'Wix', logo: 'wix.png', type: 'other', toURL: 'https://mida.freshdesk.com/support/solutions/articles/154000064027-how-to-install-mida-on-wix' },
      { plugin: 'opencart', text: 'OpenCart', logo: 'open-cart.png', type: 'other', toURL: 'https://mida.freshdesk.com/support/solutions/articles/154000064030-how-to-install-mida-on-opencart' },
      { plugin: 'joomla', text: 'Joomla', logo: 'joomla.png', type: 'other', toURL: 'https://mida.freshdesk.com/support/solutions/articles/154000062539-how-to-install-mida-on-joomla' },
      { plugin: 'magento', text: 'Magento', logo: 'magento.png', type: 'other', toURL: 'https://mida.freshdesk.com/support/solutions/articles/154000062548-how-to-install-mida-on-magento' },
    ],
    fullCode: '',
    enabledPage: {
      1: true,
      2: false
    },
    isValidURL: true,
  }),
  created() {
    console.log(this.selectedWidgetId)
    this.$http
      .post(process.env.API_ENDPOINT + '/getWidgets', {
        widget_id: this.selectedWidgetId
      })
      .then((response) => {
        let current = response.data[0]
        this.secretCode = current.widget_key
        this.websiteURL = current.widget_allowed_website
        this.setFullCode(this.secretCode)
      })
  },
  mounted() {
    this.encodedURL = encodeURI(this.websiteURL)
    this.userName = this.$session.get('name')
    if (this.$isOptimize) {
      this.selectedPlugin = this.optimizePluginList.find((x) => x.plugin === this.recommendPlugin)
    } else {
      this.selectedPlugin = this.pluginList.find((x) => x.plugin === this.recommendPlugin)
    }
    if (this.selectedPlugin.plugin === 'shopify') {
      if (this.$isOptimize) {
        this.selectedPlugin = this.optimizePluginList.find((x) => x.plugin === 'google-tag-manager')
      } else {
        this.selectedPlugin = this.pluginList.find((x) => x.plugin === 'google-tag-manager')
      }
      this.recommendPlugin = this.selectedPlugin
    }
    this.guidePlugin = this.recommendPlugin
  },
  methods: {
    setFullCode(secretCode) {
      if (this.$isOptimize) {
        this.fullCode = ''

        if (this.antiflicker) {
          this.fullCode += `&lt;!-- Anti-flickering script -->\n`    
          this.fullCode += `&lt;script>
  var timeout = 3000; // Timeout value to remove the flicker (in milliseconds)
  !function(h,i,d,e){var t,n=h.createElement("style");n.id=e,n.innerHTML="body{opacity:0}",h.head.appendChild(n),t=d,i.rmfk=function(){var t=h.getElementById(e);t&&t.parentNode.removeChild(t)},setTimeout(i.rmfk,t)}(document,window,timeout,"abhide");
&lt;/script>\n\n`
        }    

        this.fullCode += `&lt;!-- ${this.$customdomain().name} A/B Testing Script -->\n`    
        this.fullCode += `&lt;script type="text/javascript" async src="https://${this.$isMida ? 'cdn.mida.so' : 'cdn.howuku.com'}/js/optimize.js?key=${secretCode}${this.consentcode ? '&cookie=1' : ''}">&lt;/script>`
      } else {
        this.fullCode = `&lt;!-- ${this.$customdomain().name} Tracking Code -->
&lt;script>
(function(t,r,a,c,k){
  c=['track','identify','converted'],t.o=t._init||{},
  c.map(function(n){return t.o[n]=t.o[n]||function(){(t.o[n].q=t.o[n].q||[]).push(arguments);};}),t._init=t.o,
  k=r.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://${this.$getCustomCDN()}/js/${ this.$isOptimize || this.$isMida ? 'optimize' : 'track' }.js",k.setAttribute("key",a),
  r.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "${secretCode}");
&lt;/script>`
      }
    this.fullCode = this.fullCode.replace(/&lt;/g, '<')
    this.fullCode = this.fullCode.replace(/&gt;/g, '>')
    // this.fullCode = this.fullCode.replace(/ /g, '')
    this.fullCode = this.fullCode.replace(/var/g, 'var ')
    this.fullCode = this.fullCode.replace(/HowukuTrackingCode/g,' Howuku Tracking Code ')      
    },
    triggerAntiflicker() {
      this.setFullCode(this.secretCode)
    },
    triggerConsentCode() {
      this.setFullCode(this.secretCode)
    },
    otherPlatform(status) {
      if (status) {
        this.isOtherPlatform = true
        if (this.isFirstLogin) {
          this.$emit('firstLoginPaging', false)
        }
      } else {
        this.isOtherPlatform = false
        if (this.isFirstLogin) this.$emit('firstLoginPaging', true)
      }
    },
    installComplete() {
      if (this.isFirstLogin) this.$emit('installComplete')
      else if (this.isNotAddWebsite) this.$modal.hide('show-install')
      else {
        this.$modal.hide('show-installation-recommendation')
        if (!this.isNotAddWebsite) this.$modal.hide('show-create-website')
      }
    },
    showGuide(layout, plugin) {
      if (layout ===4 && !plugin) {
      } else if ((this.recommendPlugin !== "wordpress" && this.recommendPlugin !== "opencart" && this.selectedPlugin.text === "Google Tag Manager" && plugin.text === "Google Tag Manager") || 
          ((this.recommendPlugin === "wordpress" || this.recommendPlugin === "opencart") && plugin.text === "Google Tag Manager")
      ) {
        try {
          _cio.track("IS_GTM");
        } catch (e) {} 
      }
      if (this.isFirstLogin) this.$emit('firstLoginPaging', false)
      this.toLayout = layout
      if (plugin) this.guidePlugin = plugin
      this.enabledPage[this.currentPage] = false
      this.currentPage++
      this.enabledPage[this.currentPage] = true
    },
    openLink(url) {
      let installationWindow = window.open(url, '_blank')
      let interval = setInterval(() => {
        if (installationWindow.closed) {
          clearInterval(interval)
        }
        console.log('wait')
      }, 100)
    },
    backPage() {
      if (this.isFirstLogin && !this.isOtherPlatform) this.$emit('firstLoginPaging', true)
      this.enabledPage[this.currentPage] = false
      this.currentPage--
      this.enabledPage[this.currentPage] = true
    },
    doLaterDescription() {
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: `You won't be able to start using ${this.$isMida ? 'Mida' : 'Howuku'} until you install the tracking code.`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgba(var(--main-color),1)',
          cancelButtonColor: '#dcdcdc',
          confirmButtonText: 'Install Now',
          cancelButtonText: 'Continue without installing'
        })
        .then((result) => {
          if (!result.value) {
            this.$modal.hide('show-installation-recommendation')
            if (!this.isNotAddWebsite) this.$modal.hide('show-create-website')
          }
        })
    },
    copyToClipboard() {
      // 1) Add the text to the DOM (usually achieved with a hidden input field)
      const input = document.createElement('textarea')
      document.getElementById('manual-install').appendChild(input)
      input.value = this.fullCode

      // 2) Select the text
      input.focus()
      input.select()

      // 3) Copy text to clipboard
      const isSuccessful = document.execCommand('copy')
      input.parentElement.removeChild(input)

      // 4) Catch errors
      if (!isSuccessful) {
        console.error('Failed to copy text.')
      } else {
        this.$awn.success('Copied to clipboard!', {
          position: 'bottom-right',
          maxNotifications: 1,
        })   
      }
    },
    verifyWebsite() {
      // alert(234)
      console.log(this.$parent.name)
      // remove params
      this.websiteURL = this.checkProtocol(this.websiteURL.trim())
      let tempURL = this.websiteURL
      tempURL = tempURL.split('?')[0]
      // auto-assign protocol if not exist
      if (!this.validURL(tempURL, ['http', 'https'])) tempURL = 'https://' + tempURL
      if (this.isURL(tempURL)) {
        this.isValidURL = true
        this.websiteURL = tempURL
        this.$http
          .post(process.env.API_ENDPOINT + '/saveWidget', {
            widget_id: this.selectedWidgetId || this.$session.get('widget_id'),
            widget_allowed_website: this.websiteURL
          })
          .then((response) => {
            let installationStatus = 0
            if (!this.websiteURL.startsWith('http')) {
              this.websiteURL = 'https://' + this.websiteURL
            }
            let newWindow = open(
              this.websiteURL + '?verify=' + this.secretCode,
              'example',
              'width=500,height=500'
            )

            let counter = 0;
            let interval = setInterval(() => {
              // If status = 0 and after 5 seconds
              if (counter > 80 && installationStatus === 0) {
                installationStatus = 2
                clearInterval(interval)
                // close window
                newWindow.close()             
              }

              if ((newWindow.closed || counter >= 80) && installationStatus === 0) {
                installationStatus = 1
                clearInterval(interval)

                try {
                  newWindow.close()             
                } catch(x){}
                
                this.$http.get(process.env.API_ENDPOINT + '/installation/status/' + this.selectedWidgetId)
                .then((response) => {
                  if (response.status === 200) {
                    this.$modal.hide(this.$parent.name)
                    console.log(this.$parent.name)
                    // throw confetti
                    this.$router.push({ path: '/' })

                    setTimeout(() => {
                      const jsConfetti = new JSConfetti()
                      if (this.$isHowuku || this.$isMida) {
                        jsConfetti.addConfetti()
                        this.$swal.fire({
                          title: this.t('Installation successful!'),
                          text: this.t(`${this.$isMida ? 'Mida' : 'Howuku'} is capturing data on your site, and you’re ready to get started with all of ${this.$isMida ? 'Mida' : 'Howuku'}’s tools.`),
                          type: 'success',
                          confirmButtonColor: '#2167f5'
                        })
                        if (this.$isMida) this.$setInsight("Install Mida pixel", 1)
                        jsConfetti.addConfetti({
                          emojis: ['🌈', '⚡️', '💥', '✨', '💫', '🌸'],
                        })
                        try {
                          this.$auditlog({ module: 'installation', action: 'tracking_code_installed' })  
                          this.$track('tracking_code_installed')
                        } catch(e) {}
                        this.submitAnswer("Setup tracking code",1)
                        window.CREATE_EXPERIMENT = 1
                      }
                    }, 1000);
                  } else {
                    this.$swal.fire({
                      title: this.t('Cannot find tracking script'),
                      text: this.t(`We are unable to detect ${this.$isMida ? 'Mida' : 'Howuku'} tracking script on the provided website. You may wanted to recheck on your installation setup or if you have the correct website URL for verification.`),
                      type: 'error',
                      confirmButtonColor: '#2167f5'
                    })                       
                  }
                })
              }
              counter++;
            }, 100)
          })
      } else this.isValidURL = false
    },
    isURL(str) {
      let whiteSpacePattern = new RegExp('\\s', 'g')
      var pattern = new RegExp(
        '[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,9}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)|localhost',
        'ig'
      )
      return pattern.test(str) && !whiteSpacePattern.test(str)
    },
    validURL(s, protocols) {
      try {
        let url = new URL(s)
        return protocols
          ? url.protocol
            ? protocols.map(x => `${x.toLowerCase()}:`).includes(url.protocol)
            : false
          : true
      } catch (err) {
        return false
      }
    },
    checkProtocol(s) {
      // search for http or https with whitespace between
      let httpsPattern = /^\s*h\s*t\s*t\s*p\s*s\s*:\s*\/\s*\/\s*/ig
      let httpPattern = /^\s*h\s*t\s*t\s*p\s*\s*:\s*\/\s*\/\s*/ig

      if (httpPattern.test(s)) {
        return s.replace(httpPattern, 'http://')
      } else if (httpsPattern.test(s)) {
        return s.replace(httpsPattern, 'https://')
      }
      return s
    },
    submitAnswer(q, answer) {
      this.$http
        .post(process.env.API_ENDPOINT + '/user/attribute', {
          key: q,
          value: answer,
        })
        .catch((err) => {
          console.error(err)
        })
    },
  }
}
</script>

<style scoped>
.modal-template {
  padding: 25px 50px;
  overflow: auto;
  height: 100%;
  padding-bottom: 8px;
}

.paging-btn {
  margin-top: 40px;
  margin-bottom: 0px;
  display: flex;
  justify-content: space-between;
}

.plugin-row {
  display: inline-grid;
  grid-template-columns: auto auto auto auto;
  grid-gap: 20px;
  margin: 10px 0px 20px 0px;
}
.plugin-box {
  text-align: center;
  border-radius: 10px;
  padding: 25px 0px;
  width: 170px;
  text-align: center;
  border: 1px solid rgb(228, 232, 235);
  box-shadow: rgb(0 0 0 / 8%) 0px 4px 12px;
  /*box-shadow: 1px 2px 4px 1px rgba(0, 0, 0, 0.15);*/
  cursor: pointer;
}
.later-btn{
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  text-decoration: underline;
}

.text-center {
  text-align:center;
}

.text-right {
  text-align:end;
}

.option-border {
  /*border: 1px solid black;*/
  border: 1px solid rgb(228, 232, 235);
  box-shadow: rgb(0 0 0 / 8%) 0px 4px 12px;
  border-radius: 10px;
  padding: 20px;
  height: 100%;
  font-size: 110%;
}

.split {
  width: 100%;
}

.row {
  /* min-width: 100%; */
  display: flex;
}

.text-first {
  color: rgba(var(--main-color),1);
  padding-bottom: 0px;
  margin-bottom: 10px;
}

.pagination{
  display:flex;
  width: 80px;
}

.pagination .disable {
  width: 30px;
  height: 5px;
  border-radius: 999px;
  background: rgba(var(--main-color),1);
  cursor: pointer;
  transition: 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffff;
  padding: 5px;
  margin: 0px 5px;
}
.pagination .enable{
  width: 100%;
  height: 5px;
  border-radius: 999px;
  background: rgba(var(--main-color),1);
  cursor: pointer;
  transition: 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffff;
  padding: 5px;
  margin: 0px 5px;
}

.min-width-100 {
  min-width: 100% !important;
}

.overview-manual-1 {
  width: 50px;
  margin-right: 4px;
  text-align: right;
  padding-right: 0.5rem;
}

.codeBlock2 {
  max-width: 600px;
  white-space: break-spaces;
  background-color: rgba(var(--main-color),1);
  color: white;
  /* color: rgb(37, 35, 35) !important; */
  padding: 15px;
  font-size: 11px;
  word-wrap: break-word;
  overflow: hidden;
}

.margin-align {
  margin-bottom: 0.5rem;
}

.verify-input {
  display: inline-block;
}

.verify-button {
  padding-top: 11px;
  padding-bottom: 10.5px;
  margin-bottom: 20px !important;
  margin-left: 1rem;
  margin-top: 0.4rem !important;
  margin-bottom: 0.7rem !important;
}

.warning {
  color: red;
}

.share-code {
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.3rem;
  text-decoration: underline;
  color: var(--color);
}
</style>



// WEBPACK FOOTER //
// src/components/InstallRecommendation.vue